import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function loadGtag() {
  if (!GA_ID || typeof window === 'undefined' || window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });
}

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    loadGtag();
  }, []);

  useEffect(() => {
    if (!GA_ID) return;
    trackPageView({
      path: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);

  return null;
}
